// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__8u2W7","spinner":"styles_spinner__kM6PA","spin":"styles_spin__xMvRy"};
module.exports.__checksum = "b67393a6f803"
